import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/howItWorks.css"; // single combined CSS file

const TIERS = [
  {
    key: "explore",
    name: "Explore",
    days: "15 Days",
    annualPrice: "$2,199",
    monthlyPrice: "$199 / M",
    monthlyNote: "+ Tax OAC*",
    tagline: "Perfect for weekend getaways",
    featured: false,
    access: {
      headline: "All Categories",
      detail: "Standard & Compact Models",
    },
  },
  {
    key: "adventure",
    name: "Adventure",
    days: "22 Days",
    annualPrice: "$3,849",
    monthlyPrice: "$349 / M",
    monthlyNote: "+ Tax OAC*",
    tagline: "Best for families and active outdoor users.",
    featured: true,
    badge: "Most Popular",
    access: {
      headline: "All Categories",
      detail: "Recreational Models",
    },
  },
  {
    key: "elite",
    name: "Elite",
    days: "29 Days",
    monthlyPrice: "$599 / M",
    monthlyNote: "+ Tax OAC*",
    annualPrice: "$6,599",
  
    
    tagline: "Exceptional Value, Premium Convenience.",
    featured: false,
    access: {
      headline: "All Categories",
      detail: "Premium & Performance Models",
    },
  },
];

const FEATURES = [
  { label: "Insurance", values: ["Included", "Included", "Included"] },
  { label: "GPS Tracking", values: ["✓", "✓", "✓"] },
  { label: "24/7 Support", values: ["✓", "✓", "✓"] },
  { label: "Concierge Support", values: ["✓", "✓", "✓"] },
  
  { label: "Maintenance", values: ["✓", "✓", "✓"] },
  { label: "Storage", values: ["✓", "✓", "✓"] },
  { label: "Cleaning", values: ["✓", "✓", "✓"] },
];

function Cell({ value }) {
  const isCheck = value === "✓";
  const isDash = value === "—";
  return (
    <span className={`ctCell ${isCheck ? "is-check" : ""} ${isDash ? "is-dash" : ""}`}>
      {isCheck ? "✓" : value}
    </span>
  );
}

export default function HowItWorksPage() {
  const defaultKey = TIERS.find((t) => t.featured)?.key || TIERS[0].key;
  const [selectedTier, setSelectedTier] = useState(defaultKey);

  const selectedIndex = useMemo(
    () => Math.max(0, TIERS.findIndex((t) => t.key === selectedTier)),
    [selectedTier]
  );

  const activeTier = TIERS[selectedIndex];

  return (
    <div className="hiwPage">
      {/* HERO (keep this from How It Works) */}
      <header className="hiwHero">
        <div className="container hiwHero__inner">
          <div className="hiwHero__badge">Membership</div>
          <h1 className="hiwHero__title">How it works</h1>
          <p className="hiwHero__subtitle">
            Access the toys. Skip the ownership. Book what you want, when you want it — with
            maintenance, storage, and seasonal readiness handled for you.
          </p>

          <div className="hiwHero__cta">
            <Link className="btn btn--primary" to="/#join">Request club info</Link>
            <Link className="btn btn--ghost" to="/faq">Read FAQs</Link>
          </div>

          <div className="hiwHero__stats" role="list" aria-label="Membership highlights">
            <div className="hiwStat" role="listitem">
              <div className="hiwStat__num">1</div>
              <div className="hiwStat__label">Club</div>
            </div>
            <div className="hiwStat" role="listitem">
              <div className="hiwStat__num">6+</div>
              <div className="hiwStat__label">Vehicle types</div>
            </div>
            <div className="hiwStat" role="listitem">
              <div className="hiwStat__num">4</div>
              <div className="hiwStat__label">Seasons</div>
            </div>
            
          </div>
        </div>
      </header>

      <main className="hiwMain">
        {/* Steps */}
        <section className="section">
          <div className="container">
            <div className="section__head">
              <div>
                <h2 className="section__title">3 Simple Steps.</h2>
                <p className="section__subtitle">
Simple access — book what you want, when you want it.


                </p>
              </div>
            </div>

            <div className="hiwSteps">
              <article className="hiwStep">
                <div className="hiwStep__num">01</div>
                <h3 className="hiwStep__title">Select Your Club.</h3>
                <p className="hiwStep__text">
                  Pick a club tier that matches your lifestyle.


                </p>
              </article>

              <article className="hiwStep">
                <div className="hiwStep__num">02</div>
                <h3 className="hiwStep__title">Book Your Adventure.</h3>
                <p className="hiwStep__text">
                  Reserve vehicles through your member services.


                </p>
              </article>

              <article className="hiwStep">
                <div className="hiwStep__num">03</div>
                <h3 className="hiwStep__title">Enjoy The Outdoors.</h3>
                <p className="hiwStep__text">
                  Pick up, ride, return — we'll handle the rest.


                </p>
              </article>
            </div>
          </div>
        </section>

        {/* Membership tiers (from Club Tiers) */}
        <section className="section">
          <div className="container">
            <div className="section__head">
              <div>
                <h2 className="section__title">Club Pricing</h2>
                <p className="section__subtitle">
                  Pick the access level that matches how often you want to get out.
                </p>
              </div>
            </div>

            <div className="ctCards">
              {TIERS.map((t) => (
                <article key={t.key} className={`ctCard ${t.featured ? "is-featured" : ""}`}>
                  {t.featured && <div className="ctCard__badge">{t.badge || "Most Popular"}</div>}

                  <div className="ctCard__top">
                    <h3 className="ctCard__name">{t.name}</h3>
                    <div className="ctCard__days">{t.days}</div>
                    <p className="ctCard__tag">{t.tagline}</p>
                  </div>

                  <br/>
                   <div className="ctPriceBlock">
                      <div className="ctPriceBlock__label">Monthly Payment - 12 Month Term.</div>
                      <div className="ctPriceBlock__value">
                        {t.monthlyPrice} <span className="ctMuted">{t.monthlyNote}</span>
                      </div>
                    </div>

                    <br></br>
                    <div className="ctCard__or">
                      OR
                    </div>

                  <div className="ctPrices">
                    <div className="ctPriceBlock">
                      <div className="ctPriceBlock__label">Annual Payment</div>
                      <div className="ctPriceBlock__value">
                        {t.annualPrice} <span className="ctMuted">+ Tax</span>
                      </div>
                    </div>

                   
                  </div>

                  <div className="ctAccess">
                    <div className="ctAccess__title">Vehicle Access</div>
                    <div className="ctAccess__headline">{t.access.headline}</div>
                    <div className="ctAccess__detail">{t.access.detail}</div>
                  </div>

                  <div className="ctCard__actions">
                    <Link className={`btn ${t.featured ? "btn--primary" : "btn--ghost"} ctCard__btn`} to="/#join">
                      Join {t.name}
                    </Link>
                    <Link className="link ctCard__link" to="/clubs">
                      Compare
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* What's included (from Club Tiers) */}
        <section className="section section--muted">
          <div className="container">
            <div className="section__head">
              <div>
                <h2 className="section__title">What’s included</h2>
                <p className="section__subtitle">
                  Every club includes the essentials — compare the details.
                </p>
              </div>
            </div>

            {/* Desktop table */}
            <div className="ctTableWrap" aria-label="Club tiers comparison table">
              <table className="ctTable">
                <thead>
                  <tr>
                    <th className="ctTable__feature">Feature</th>
                    {TIERS.map((t) => (
                      <th key={t.key} className={`ctTable__plan ${t.featured ? "is-featured" : ""}`}>
                        
                        <div className="ctPlanName">{t.name}</div>
                        <div className="ctPlanMeta">{t.days}</div>
                        <br/>
                        {t.featured && <div className="ctPill">Most Popular</div>}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  
                  {FEATURES.map((row) => (
                    <tr key={row.label}>
                      <th className="ctTable__rowLabel">{row.label}</th>
                      {row.values.map((v, idx) => (
                        <td key={`${row.label}-${idx}`} className="ctTable__cell">
                          <Cell value={v} />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Mobile picker */}
            <div className="ctMobile" aria-label="Mobile club comparison">
              <div className="ctTabs" role="tablist" aria-label="Select club tier">
                {TIERS.map((t) => {
                  const isActive = selectedTier === t.key;
                  return (
                    <button
                      key={t.key}
                      type="button"
                      role="tab"
                      aria-selected={isActive}
                      className={`ctTab ${isActive ? "is-active" : ""} ${t.featured ? "is-featured" : ""}`}
                      onClick={() => setSelectedTier(t.key)}
                    >
                      <div className="ctTab__top">
                        <span className="ctTab__name">{t.name}</span>
                        {t.featured && <span className="ctTab__pill">Popular</span>}
                      </div>
                      <div className="ctTab__meta">
                        <span className="ctTab__price">{t.monthlyPrice}</span>
                        <span className="ctTab__days">{t.days}</span>
                      </div>
                    </button>
                  );
                })}
              </div>

              <article className="ctMobileCard">
                <div className="ctMobileCard__head">
                  <div>
                    <div className="ctMobileCard__title">{activeTier.name}</div>
                    <div className="ctMobileCard__sub">
                      <span className="ctStrong">{activeTier.annualPrice}</span> <span className="ctMuted">+ Tax</span>{" "}
                      • <span className="ctStrong">{activeTier.monthlyPrice}</span>{" "}
                      <span className="ctMuted">{activeTier.monthlyNote}</span>
                    </div>
                  </div>

                  <Link className={`btn ${activeTier.featured ? "btn--primary" : "btn--ghost"}`} to="/#join">
                    Join
                  </Link>
                </div>

                <div className="ctMobileList" role="list">
                  <div className="ctMobileRow" role="listitem">
                    <div className="ctMobileRow__label">Annual Days</div>
                    <div className="ctMobileRow__value">
                      <Cell value={activeTier.days} />
                    </div>
                  </div>

                  {FEATURES.map((row) => (
                    <div key={row.label} className="ctMobileRow" role="listitem">
                      <div className="ctMobileRow__label">{row.label}</div>
                      <div className="ctMobileRow__value">
                        <Cell value={row.values[selectedIndex]} />
                      </div>
                    </div>
                  ))}
                </div>
              </article>
            </div>
          </div>
        </section>

        {/* Bottom CTA */}
        <section className="hiwCta">
          <div className="container hiwCta__inner">
            <div>
              <h2 className="hiwCta__title">Ready to see membership options?</h2>
              <p className="hiwCta__text">
                Tell us your season and interests — we’ll recommend the best tier and explain how booking works.
              </p>
            </div>
            <div className="hiwCta__actions">
              <Link className="btn btn--primary" to="/#join">Request info</Link>
              <Link className="btn btn--ghost" to="/faq">FAQ</Link>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
